import { theme } from "../theme";

export const componentsStyles = {
  panel: {
    sx: {
      transform: "translate(35%, 680px) !important",
      width: "60%",
      "& .MuiDataGrid-filterForm": {
        "& .MuiInput-root": {
          border: "1px solid rgba(224,224,224,1)",
          marginTop: "24px",
          borderRadius: "6px",
          "&::before, &::after": {
            content: "unset",
          },
        },
      },
      "& .MuiPaper-root": {
        minHeight: "8rem",
        padding: "1rem 4rem 0",
        position: "relative",
        display: "flex",
        alignItems: "center",
        justifyContent: "space-evenly",
        ".statusSelect": {
          width: "80%",
          ".selectLabel": {
            color: theme.palette.primary.main,
            fontSize: "1.5rem",
            top: "-25px",
          },
        },
        "& .MuiNativeSelect-select": {
          height: "46px",
          padding: "0px 18px",
          "&:hover": {
            bgcolor: "rgba(224,224,224,0.6)",
            borderRadius: "4px",
          },
        },
        "& .MuiInput-root": {
          height: "46px",
          width: "100%",
          border: "1px solid rgba(224,224,224,1)",
          marginTop: "0",
          borderRadius: "4px",
          "&::before, &::after": {
            content: "unset",
          },
        },
        "& 	.MuiButton-root": {
          textTransform: "capitalize",
          height: "46px",
          border: "1px solid rgba(224,224,224,1)",
          color: theme.palette.primary.black,
          flexDirection: "row-reverse",
          justifyContent: "space-around",
          "& span": {
            margin: "0",
          },
          ":hover": {
            background: "rgba(0,0,0,0.1)",
          },
        },
      },
    },
  },
};

export const toolbarPropStyles = {
  sx: {
    marginTop: "32px",
    padding: "1rem 4rem 0",
    height: "128px",
    width: "50%",
    display: "flex",
    alignItems: "center",
    justifyContent: "space-evenly",
    "& .MuiDataGrid-filterForm": {
      "& .MuiInput-root": {
        border: "1px solid rgba(224,224,224,1)",
        marginTop: "24px",
        borderRadius: "6px",
        "&::before, &::after": {
          content: "unset",
        },
      },
    },
    ".statusSelect": {
      width: "80%",
      ".selectLabel": {
        color: theme.palette.primary.main,
        fontSize: "1.5rem",
        top: "-25px",
      },
    },
    "& .MuiNativeSelect-select": {
      height: "46px",
      padding: "0px 18px",
      "&:hover": {
        bgcolor: "rgba(224,224,224,0.6)",
        borderRadius: "4px",
      },
    },
    "& .MuiInput-root": {
      height: "46px",
      width: "100%",
      border: "1px solid rgba(224,224,224,1)",
      marginTop: "0",
      borderRadius: "4px",
      "&::before, &::after": {
        content: "unset",
      },
    },
    "& 	.MuiButton-root": {
      textTransform: "capitalize",
      height: "46px",
      border: "1px solid rgba(224,224,224,1)",
      color: theme.palette.primary.black,
      flexDirection: "row-reverse",
      justifyContent: "space-around",
      "& span": {
        margin: "0",
      },
      ":hover": {
        background: "rgba(0,0,0,0.1)",
      },
    },
  },
};

export const dialogStyles = {
  maxWidth: "sm",
  title: {
    fontSize: "2rem",
    fontWeight: "700",
    color: theme.palette.primary.black,
  },
  content: {
    fontSize: "1.5rem",
    color: theme.palette.primary.black,
  },
  box: {
    "& .MuiDialog-paper": {
      padding: "3rem",
    },
  },
  cancelButton: theme.button.bgColorGray,
  ctaButton: theme.palette.primary.black,
  display: "none",
};

export const MenuProps = {
  sx: {
    "& .MuiMenu-list": {
      "& .Mui-disabled": {
        display: "none",
      },
    },
  },
};
